function AboutMeParagraph() {
    return (
        <div>
            <h2 className = "Sub-header-text mb-5">Who am I?</h2>
                        <p className='Paragraph-text mb-5'>
                            I'm a laid back guy who recenty graduated from the Georgia Institute of Technology and I am looking to make an impact in the world of technology.
                        </p>
                        <p className='Paragraph-text mb-5'>
                            As I've gone through college my interest in software development has grown exponentially and I find my self spending a lot of time
                            learning looking at what people are making with artificial intelligence or what new methods are being used in game development.
                             I have even gone as far as drafting up an 
                            <a href="https://docs.google.com/document/d/1GWVwfr6yzPxb3j2Ju-D6X6yrkPPnUhi55I8TP993puw/edit?usp=sharing" target={"_blank"} rel="noreferrer"> essay </a> 
                            on AI generated art for an ethics course I took.
                        </p>
                        <p className='Paragraph-text mb-5'>
                            If i'm not doing something technology related, I am most likely playing video games, watching tv/anime, or reading posts about how the ChatGPT ai is 
                            <i> supposedly </i>
                            going to delete all the software developer jobs.
                        </p > 
                        <p className='Paragraph-text mb-5'>
                            
                        </p>
        </div>
    )
}

export default AboutMeParagraph;